<template>
    <v-dialog
        transition="dialog-bottom-transition"
        max-width="1000px"
        v-model="dialog"
    >
        <template v-slot:activator="{ props: activatorProps }">
            <v-btn
                v-if="typeButton"
                v-bind="activatorProps"
                icon="mdi mdi-file-eye"
                class="ml-2"
            ></v-btn>
            <v-tooltip v-else>
            <template v-slot:activator="{ props: tooltipProps }">
                <v-btn
                    v-if="errorCargaArchivo"
                    v-bind="{ ...activatorProps, ...tooltipProps }"
                    icon="mdi mdi-paperclip"
                    color="red"
                ></v-btn>
                <v-btn
                    v-else
                    v-bind="{ ...activatorProps, ...tooltipProps }"
                    icon="mdi mdi-paperclip"
                ></v-btn>
            </template>
            <span>{{ tiposDocumentacionTotal() }}</span>
        </v-tooltip>
        </template>

        <template v-slot:default="{ isActive }">
            <v-card>
                <v-toolbar :title="headerText" class="modal-header"></v-toolbar>
                <!-- <v-data-table 
                    v-if="files.length > 0"
                    :headers="headers"
                    :items="files"
                    :items-per-page="5"
                    :items-per-page-options="[5, 10, 15]"
                    height="100%"
                    item-value="name"
                >
                    <template v-slot:[`item.tipoDocumentacion`]="{ item }">
                        <v-chip
                            color="primary"
                            class="white--text"
                        >
                            {{ tipoDocumentacion(item.tipoDocumentacion) }}
                        </v-chip>
                    </template>
                    <template v-slot:[`item.contenidoBase64`]="{ item }">
                        <v-row class="align-center justify-start" dense>
                            <v-col cols="12" :md="mostrarAcciones && puedeEliminarArchivo() ? 4 : 6">
                                <v-btn
                                    @click="openFileInNewTab(item.tipoMime, item.nombre, item.guid)"
                                    icon="mdi mdi-eye"
                                >
                                </v-btn>
                            </v-col>
                            <v-col  cols="12" :md="mostrarAcciones && puedeEliminarArchivo() ? 4 : 6">
                                <v-btn
                                    @click="downloadFile(item.tipoMime, item.nombre, item.guid)"
                                    icon="mdi mdi-download"
                                >
                                </v-btn>
                            </v-col>
                            <v-col  cols="12" md="4" v-if="mostrarAcciones && puedeEliminarArchivo()">
                                <v-btn
                                    v-if="puedeEliminarArchivo()"
                                    @click="elimimarArchivo(item.dominio, item.guid, item.idSolicitudPractica, item.tipoDocumentacion)"
                                    icon="mdi mdi-trash-can"
                                >
                                </v-btn>
                            </v-col>
                        </v-row>
                    </template>
                </v-data-table> -->
                <ImageTable
                    v-if="files.length > 0"
                    :files="files"
                    :headers="headers"
                    :tiposDocumentacion="tiposDocumentacion"
                    :mostrarEnviar="errorCargaArchivo"
                    :mostrarEliminar="mostrarAcciones"
                    :esDeReintegros="esDeReintegros()"
                    :esAuditor="esAuditor()"
                    @eliminar-archivo="elimimarArchivo"
                    @open-file-in-new-tab="openFileInNewTab"
                    @download-file="downloadFile"
                    @enviar-docu-IOMA="enviarDocuIOMA"
                ></ImageTable>
                <v-card-title v-else class="my-text-black">
                    No hay archivos asociadas a la solicitud
                </v-card-title>
                <v-card-actions class="justify-end">
                    <v-btn
                        text="Cerrar"
                        id="boton-verde"
                        @click="isActive.value = false"
                    ></v-btn>
                </v-card-actions>
            </v-card>
        </template>
    </v-dialog>
    <AlertComponent
        :title="alertTitle"
        :text="alertText"
        :alertType="alertType"
        :showAlert="showAlert"
        @close="showAlert = false"
    ></AlertComponent>
    <ConfirmacionDialog
    :dialogConfirm="dialogConfirm"
    :mensajeConfirm="mensajeConfirm"
    @confirmar="confirmar"
    @cancelar="cancelar"
    />
</template>

<script>
import PrestacionService from '@/api/PrestacionService';
import GeneralService from '@/api/GeneralService';
import AlertComponent from './AlertComponent.vue';
import ConfirmacionDialog from './ConfirmacionDialog.vue';
import { nextTick } from 'vue';
import { Role } from '@/_helpers/role';
import ImageTable from './ImageTable.vue';

const generalService = new GeneralService();
const prestacionService = new PrestacionService();

/* eslint-disable */
export default {
    components: {
        AlertComponent,
        ConfirmacionDialog,
        ImageTable
    },
    props: {
        buttonText: {
            type: String,
            default: 'Ver documentación'
        },
        headerText: {
            type: String,
            default: 'Documentación respaldatoria'
        },
        archivos: {
            type: Array,
            default: () => []
        },
        detalle: {
            type: Array,
            default: () => []
        },
        typeButton: {
            type: Boolean,
            default: false
        },
        errorCargaArchivo:{
            type: Boolean,
            default: false
        },
        idSolicitud: {
            type: String,
            default: ''
        },
        mostrarAcciones: {
            type: Boolean,
            default: true
        },
        tiposDocumentacion: {
            type: Array,
            required: true
        },
        esPracticaPesada: {
            type: Boolean,
            default: false
        }, 
        estadoSolicitud: {
            type: String,
            default: ''
        }
    },
    async mounted() {
        // this.tiposDocumentacion.push({valor:3, nombre:'Carnet afiliado'});
        if(this.archivos.length > 0){
            this.archivos.forEach(archivo => {
                this.files.push({
                    dominio: 'General',
                    nombre: archivo.nombre,
                    fechaCreacion: archivo.fechaCreacion ? (this.parsearFecha(archivo.fechaCreacion)) : 'No indicada',
                    tipoMime: archivo.tipoMime,
                    contenidoBase64: '',
                    idSolicitudPractica: '',
                    guid: archivo.guid,
                    tipoDocumentacion: archivo.tipoDocumentacion
                })
            });
        }
        if(this.detalle.length > 0){
            this.detalle.forEach(d => {
                if(d.files && d.files.length > 0) {
                    d.files.forEach(f => {
                        this.files.push({
                            dominio: d.prestacioncodigo,
                            nombre: f.nombre,
                            fechaCreacion: f.fechaCreacion ? (this.parsearFecha(f.fechaCreacion)) : 'No indicada',
                            tipoMime: f.tipoMime,
                            contenidoBase64: '',
                            idSolicitudPractica: d.id,
                            guid: f.guid,
                            tipoDocumentacion: f.tipoDocumentacion
                        })
                    });
                }
            });
        }
    },
    beforeUnmount() {
        if (this.blobUrl) {
            URL.revokeObjectURL(this.blobUrl);
        }
    },
    computed: {
        tipoDocumentacion() {
            return (valor) => {
                const tipo = this.tiposDocumentacion.find(tipo => tipo.valor === valor);
                return tipo ? tipo.nombre : null;
            };
        }
    },
    data: () => ({
        headers: [
            { title: 'Dominio', key: 'dominio'},
            { title: 'Documentación', key: 'tipoDocumentacion'},
            { title: 'Nombre', key: 'nombre' },
            { title: 'Fecha de creación', key: 'fechaCreacion' },
            { title: 'Tipo', key: 'tipoMime' },
            { title: 'Acciones', key: 'contenidoBase64' }
        ],
        files: [],
        blobUrl: null,
        archivoAEliminar: {
            idSolicitud: "",
            idSolicitudPractica: null,
            idArchivo: "",
        },
        //datos para mostrar info
        alertTitle: '',
        alertText: '',
        alertType: '',
        showAlert: false,
        cargando: false,
        dialog: false,
        dialogConfirm: false,
        mensajeConfirm: '',
        resolverConfirm: null,
    }),
    methods: {
        async recuperarArchivo(mimeType, fileName, guid) {
            //fileName, mimeType,
            const response = await generalService.getArchivo(guid);
            if(response && response.status === 200){
                const mimeType = response.data.tipoMime; //rafa
                const base64Content = response.data.contenidoBase64;
                const byteCharacters = atob(base64Content);
                const byteNumbers = new Array(byteCharacters.length);
                for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);

                const blob = new Blob([byteArray], { type: mimeType });

                this.blobUrl = URL.createObjectURL(blob);
            }
            else{
                this.alertTitle = 'Error';
                this.alertText = 'Ha ocurrido un error al recuperar el archivo';
                this.alertType = 'error';
                this.showAlert = true;
            }
        },
        async downloadFile({ tipoMime, nombre, guid }) { //usarlo si se quiere descargar automaticamente
            await this.recuperarArchivo(tipoMime,nombre,guid);
            //realiza la descarga del archivo
            const a = document.createElement('a');
            a.href = this.blobUrl;
            a.download = nombre;

            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(this.blobUrl);
        },
        archSensible(tipoArch){
            return tipoArch == 0 || tipoArch == 5;
        },
        mostrarConfirmacion(mensaje) {
            this.mensajeConfirm = mensaje;
            this.dialogConfirm = true;
            return new Promise((resolve) => {
                this.resolverConfirm = resolve;
            });
        },
        confirmar() {
            this.dialogConfirm = false;
            if (this.resolverConfirm) this.resolverConfirm(true);
            this.resolverConfirm = null;
        },
        cancelar() {
            this.dialogConfirm = false;
            if (this.resolverConfirm) this.resolverConfirm(false);
            this.resolverConfirm = null;
        },
        async elimimarArchivo({dominio,idArchivo, idSolicitudPractica, tipoDocumentacion}) {
            const mensaje = this.esPracticaPesada && this.archSensible(tipoDocumentacion)
                ? "¿Estás seguro que querés eliminar este archivo? Advertencia: Si se elimina esta documentación de una práctica pesada la misma ya no será vista por los autorizadores hasta que se vuelva a cargar."
                : "¿Estás seguro que querés eliminar este archivo?";

            const confirmacion = await this.mostrarConfirmacion(mensaje);
            if (!confirmacion) return;
            this.cargando = true;
            this.archivoAEliminar.idArchivo = idArchivo;
            this.archivoAEliminar.idSolicitud = this.idSolicitud;
            if(dominio !== 'General'){
                this.archivoAEliminar.idSolicitudPractica = idSolicitudPractica;
            }
            else{
                this.archivoAEliminar.idSolicitudPractica = null;
            }
            const response = await prestacionService.eliminarArchivoDeSolicitud(this.archivoAEliminar);
            this.dialog = false;
            this.cargando = false;
            this.$emit('archivo-eliminado', response);
        },
        puedeEliminarArchivo() {
            return !(this.esDeReintegros() || this.esAuditor() || this.esAutorizador()) 
                && !(this.estadoSolicitud === 'Facturable' || this.estadoSolicitud === 'Rechazada');
        },
        async openFileInNewTab({ tipoMime, nombre, guid }) {//usarlo si se quiere tener una vista previa primero
            await this.recuperarArchivo(tipoMime, nombre,guid);

            const newTab = window.open(this.blobUrl, '_blank');
            if (!newTab) {
                alert('Por favor, permite las ventanas emergentes para este sitio.');
            }
        },
        esDeReintegros(){
            const rol = this.$store.getters.getRole;
            return rol === Role.Paciente || rol === Role.AdministrativoReintegros;
        },
        esAuditor(){
            const rol = this.$store.getters.getRole
            return rol == Role.Auditor || rol == Role.AuditorGeneral;
        },
        esAutorizador(){
            return this.$store.getters.getRole == Role.Autorizador;
        },
        tiposDocumentacionTotal(){
            return [...new Set(this.files.map(file => this.tipoDocumentacion(file.tipoDocumentacion)))].join(', ');
        },
        async enviarDocuIOMA({guid}){
            this.cargando = true;
            const response = await prestacionService.enviarArchivoIOMA(guid);
            this.dialog = false;
            this.cargando = false;
            this.$emit('archivo-cargado', response)
        },
        parsearFecha(fechaString){
            const date = new Date(fechaString);
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const year = date.getFullYear();
            return `${day}/${month}/${year}`;
        }
    }
}
</script>